var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.75,
    height: 33.75,
    viewBox: "0 0 33.75 33.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_core-arrow-circle-right",
    "data-name": "Icon core-arrow-circle-right",
    transform: "translate(-1.143 -1.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M18.018,1.128A16.875,16.875,0,1,0,34.893,18,16.875,16.875,0,0,0,18.018,1.128ZM28.359,28.344A14.572,14.572,0,1,1,31.494,23.7a14.572,14.572,0,0,1-3.135,4.649Z",
    fill: "#2c39e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M16.849,11.6l5.277,5.277H9.01v2.25H22.127l-5.277,5.277L18.44,26,26.434,18,18.44,10.01Z",
    fill: "#2c39e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.44d64676c4d3c19f444e559b341c8857.svg";
export { ForwardRef as ReactComponent };